import { getPreciseFormattedStorage } from 'app/components/Storage/utils';
import { AudioFormValidationProperties } from 'types/audio';

export const getFileUploadErrorMessage = (
  file: File,
  validations?: AudioFormValidationProperties
) => {
  if (validations && file.size <= validations?.fileSize?.minimum) {
    return `Audio file (${file.name}) is too small. Please try again with a larger file`;
  }

  if (validations && file.size >= validations?.fileSize?.maximum) {
    const maxSize = getPreciseFormattedStorage(
      validations?.fileSize?.maximum || 0
    );
    return `Audio file (${file.name}) is too large. Maximum allowed file size is ${maxSize}`;
  }

  if (
    validations &&
    file.name.length > validations?.originalFileName?.maxLength
  ) {
    return `File (${file.name}) name is too long. Max ${validations?.originalFileName?.maxLength} characters`;
  }

  return null;
};
